import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'confirm-dialog',
    templateUrl: 'confirm-dialog.html',
    styleUrls: ['./confirm-dialog.css']
})
export class ConfirmDialog {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialog>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

    closeDialog(): void {
        this.dialogRef.close(false);
    }
    confirm(): void {
        this.dialogRef.close(true);
    }
}

export interface DialogData {
    message: string;
}